import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { MemberUser } from '@youhelp-ru/core';
import { BotIdentificator } from '@common/model/bot';
import { MessageType } from '@common/model/dialog/message/messageType';
import {
  DialogMessageRenderer,
  MessageDate,
  MessageDelivery,
  MessageFooter,
  currentDialogModel,
  useCurrentDialogMember,
} from '@cp/entities/dialog';
import { DealMessageRenderer } from '@cp/entities/deal';
import { adminDealApi } from 'src/entities/deal';

export const DealPropositionRenderer: DialogMessageRenderer<MessageType.DealProposition> = ({ message }) => {
  const dialogMember = useCurrentDialogMember();
  const dialog = useSelector(currentDialogModel.selectors.currentDialogSelector);
  const currentMember = useMemo(() => MemberUser.bot(BotIdentificator.SupportBot), []);
  const { data: deal } = adminDealApi.endpoints.getOne.useQuery({ dealId: message.payload.dealId });

  const participatingMember = dialogMember?.entityId ? MemberUser.client(dialogMember.entityId) : undefined;

  const footer = useCallback(
    () => (
      <MessageFooter>
        <MessageDelivery message={message} />
        <MessageDate message={message} />
      </MessageFooter>
    ),
    [message],
  );

  if (!dialog || !deal) {
    return null;
  }

  return (
    <DealMessageRenderer
      currentMember={currentMember}
      deal={deal}
      dialog={dialog}
      flags={{ markAsRead: false }}
      message={message}
      participatingMember={participatingMember}
      slots={{ footer }}
    />
  );
};
